import {styled} from "@mui/material";
import {DatePicker} from "@mui/x-date-pickers";
import {COLORS} from "../../../constants/constants";

export const DatePickerMui = styled(DatePicker)<{isValid?: boolean; iconSize?: number}>`
  width: 100%;

  .MuiInputBase-root {
    font-size: 14px !important;
    width: 100%;
    height: 32px !important;
    margin: 0 !important;
    background-color: ${COLORS.WHITE} !important;

    .MuiInputBase-input {
      padding: 8px !important;
      padding-right: 0 !important;
    }

    .MuiOutlinedInput-notchedOutline {
      border: ${(props) => (props.isValid !== false ? "solid 1px #dedede !important" : "solid 1px #cd4246 !important")};
    }

    ::placeholder {
      color: ${COLORS.COLOR_PLACE_HOLDER} !important;
    }
  }

  svg {
    font-size: ${(props) => props.iconSize || 20}px !important;
  }

  button {
    padding: 4px !important;
    margin: 0 2px 0 0 !important;
  }
`;
